var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-12 py-8 c-single-button bg-white"},[_c('c-button',_vm._g(_vm._b({attrs:{"block":"","type":"info"}},'c-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }